import { Platform } from 'react-native';
import { CustomIcon } from './CustomIcon';
import { IconSizeValue, isLucideIcon, NoddiIconName } from './icon';
import { ReactNativeLucideIcon } from './ReactNativeLucideIcon';

export interface IconProps {
  name: NoddiIconName;
  size?: IconSizeValue;
  color?: string;
  className?: string;
  absoluteStrokeWidth?: boolean; // Only applicable for Lucide icons
  strokeWidth?: number; // Only applicable for Lucide icons
}

export function NoddiIcon({ name, size, color, className, absoluteStrokeWidth, strokeWidth }: IconProps) {
  const isMobile = Platform.OS === 'android' || Platform.OS === 'ios';

  const sizeToUse = size ?? (isMobile ? 'xMedium' : size);
  if (isLucideIcon(name)) {
    return (
      <ReactNativeLucideIcon
        name={name}
        size={sizeToUse}
        color={color}
        className={className}
        absoluteStrokeWidth={absoluteStrokeWidth}
        strokeWidth={strokeWidth}
      />
    );
  } else {
    return <CustomIcon name={name} size={sizeToUse} color={color} className={className} />;
  }
}
